import { render, staticRenderFns } from "./AutoCompleteAssignedComponent.vue?vue&type=template&id=aab589c4&"
import script from "./AutoCompleteAssignedComponent.vue?vue&type=script&lang=js&"
export * from "./AutoCompleteAssignedComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports